import React from 'react';
import { Navigation } from '../components/Navigation';
import { HeroVariant81 } from '../components/HeroVariant81';
import { About } from '../components/About';
import { Services } from '../components/Services';
import { WhyUs } from '../components/WhyUs';
import { Stats } from '../components/Stats';
import { Testimonials } from '../components/Testimonials';
import { FAQ } from '../components/FAQ';
import { Consultation } from '../components/Consultation';
import { Footer } from '../components/Footer';
import { CookieBanner } from '../components/CookieBanner';
import { FloatingContact } from '../components/FloatingContact';
export function LandingPage81() {
  return <div className="min-h-screen bg-[var(--bg-primary)] text-[var(--text-primary)] transition-colors duration-300" data-id="element-1834">
      <Navigation data-id="element-1835" />
      <main data-id="element-1836">
        <HeroVariant81 data-id="element-1837" />
        <About data-id="element-1838" />
        <Services data-id="element-1839" />
        <WhyUs data-id="element-1840" />
        <Stats data-id="element-1841" />
        <Testimonials data-id="element-1842" />
        <FAQ data-id="element-1843" />
        <Consultation data-id="element-1844" />
      </main>
      <Footer data-id="element-1845" />
      <CookieBanner data-id="element-1846" />
      <FloatingContact data-id="element-1847" />
    </div>;
}